import script from "./Item.vue?vue&type=script&setup=true&lang=js"
export * from "./Item.vue?vue&type=script&setup=true&lang=js"

import "./Item.vue?vue&type=style&index=0&id=2d6884ef&lang=scss&scoped=true"
script.__scopeId = "data-v-2d6884ef"

export default script